import React from "react";
import { FaQuoteLeft } from "react-icons/fa6";
import { FaQuoteRight } from "react-icons/fa6";

const MessageSection = () => {
  return (
    <div className="flex items-center justify-center bg-gray-100 h-96">
      <div className="text-center p-6 max-w-3xl">
        {/* Icons placed above the paragraph with space */}
        <div className="flex justify-center space-x-4 mb-4">
          <FaQuoteLeft className="text-3xl text-[#004E98]" />
          <FaQuoteRight className="text-3xl text-[#004E98]" />
        </div>

        {/* Message */}
        <p className="text-lg text-[#004E98]">
          Finding the right message for your marketing can be hard. <br /> But
          aligning with a cause that people care about can make a real
          difference.
        </p>
      </div>
    </div>
  );
};

export default MessageSection;
